export const AuthHeaders = {
  Authorization: 'authorization',
  Bearer: 'Bearer',
};
